import { HeadlineCtaCenteredSliceWithDescription } from '../../../../prismicio-types';
import React, { FC } from 'react';
import HighlightedText from '@/components/HighlightedText/HighlightedText';
import { asText } from '@prismicio/client';
import { PrismicRichText } from '@prismicio/react';
import { PrismicNextLink } from '@prismicio/next';

interface HeadlineCtaCenteredProps {
  slice: HeadlineCtaCenteredSliceWithDescription;
}

const WithDescription: FC<HeadlineCtaCenteredProps> = (props) => {
  const { headline, description, primary_cta, cta_label } = props.slice.primary;

  return (
    <div className="text-center text-white max-w-4xl mx-auto py-16 mt-10">
      <h2 className="font-inter font-medium text-[42px] leading-[120%] text-center">
        <HighlightedText text={asText(headline) || ''} />
      </h2>

      {description && (
        <p className="font-inter font-normal text-[16px] leading-[150%] text-center mt-10">
          <PrismicRichText field={description} />
        </p>
      )}

      {primary_cta && (
        <PrismicNextLink
          field={primary_cta}
          className="inline-block px-8 py-3 rounded-full bg-[#333] hover:bg-[#05F36C] transition mt-10"
        >
          {cta_label || 'Talk to an Expert'}
        </PrismicNextLink>
      )}
    </div>
  );
};

export default WithDescription;
